import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import StkCikisDTO from 'src/models/StokEczane/CikisIslemleri/StkCikisDTO';
import VwStkCikisDTO from 'src/models/StokEczane/CikisIslemleri/VwStkCikisDTO';
import StkGirisDTO from 'src/models/StokEczane/GirisIslemleri/StkGirisDTO';
import VwStkGirisDTO from 'src/models/StokEczane/GirisIslemleri/VwStkGirisDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { GridFilterModel } from "@mui/x-data-grid";
import StkCikisSearchDTO from 'src/models/StokEczane/CikisIslemleri/StkCikisSearchDTO';
import { helper } from 'src/utils/helper';

interface IStokCikisState {
  isSearchSubmit: boolean;
  stokCikisList: VwStkCikisDTO[];
  stokSearchState: boolean;
  activeStokCikis: StkCikisDTO;
  activeStokCikisId?: number;
  stokCikisHastaservisId?: number;
  refetch: boolean;
  dataGridFilter: GridFilterModel;
  aramaKriterleri: StkCikisSearchDTO;

}

const StokCikisSlice = createSlice<
  IStokCikisState,
  MapReducerPayloads<
    IStokCikisState,
    {
      setIsSearchSubmit: boolean;
      setStokCikisList: VwStkCikisDTO[];
      setStokSearchState: boolean;
      setActiveStokCikis: StkGirisDTO;
      setActiveStokCikisId: number;
      setActiveStokCikisHastaservisId: number;
      setStokCikisHastaservisId: number;
      setRefetch: boolean;
      setDataGridFilter: GridFilterModel;
      setAramaKriterleri: StkCikisSearchDTO;
    }
  >
>({
  name: 'StokCikis',
  initialState: {
    isSearchSubmit: true,
    stokCikisList: null,
    stokSearchState: false,
    activeStokCikis: null,
    stokCikisHastaservisId: null,
    refetch: false,
    dataGridFilter: { items: [] },
    aramaKriterleri: {
      ...new StkCikisSearchDTO(),
      eklemeTarihiBaslangic: helper.beforeDays(new Date(), 1),
      eklemeTarihiBitis: new Date(),
    },
  },
  reducers: {
    setIsSearchSubmit: (state, action) => {
      state.isSearchSubmit = action.payload;
    },
    setStokCikisList: (state, action) => {
      state.stokCikisList = action.payload;
    },
    setStokSearchState: (state, action) => {
      state.stokSearchState = action.payload;
    },
    setActiveStokCikis: (state, action) => {
      state.activeStokCikis = action.payload;
    },
    setActiveStokCikisId: (state, action) => {
      state.activeStokCikisId = action.payload;
    },
    setActiveStokCikisHastaservisId: (state, action) => {
      if (state.activeStokCikis != null)
        state.activeStokCikis.hastaservisId = action.payload;
    },
    setStokCikisHastaservisId: (state, action) => {
      state.stokCikisHastaservisId = action.payload;
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload
    },
    setDataGridFilter: (state, action: PayloadAction<GridFilterModel>) => {
      state.dataGridFilter = action.payload;
    },
    setAramaKriterleri: (state,action) => {
      state.aramaKriterleri = action.payload;
    },
  }
});

export default StokCikisSlice;
